import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from "../../../_services/api-request.service";
import { MaterializeAction } from "angular2-materialize";

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  UserDetail: any;
  FirstLetter: any;
  loader = false;
  history_logs: any;
  history_cols: any;
  


  constructor(private apirequest: ApiRequestService) { }

  ngOnInit() {
    let info = JSON.parse(localStorage.getItem("currentUser"));
    this.UserDetail = info;
    let word = this.UserDetail.FirstName;
    this.FirstLetter = word.split("");
    this.get_logs();
    setTimeout(() => {
      $(document).ready(function () {
        $('ul.tabs').tabs();
      });
    }, 10);
  }


  get_logs() {
    this.loader = true;
    console.log(this.UserDetail._id);
    let data = {
      action: (this.UserDetail._id == "anwar@codexnow.com") ? "get_logs_all" : (this.UserDetail._id !== "anwar@codexnow.com") ? "get_logs"  : "get_logs"
    };
    //console.log(data);
    this.apirequest.customize_flow(data).subscribe((res) => {
      // console.log(res);
      if (res.status == true) {
        this.loader = false;
        this.history_logs = res.logs.reverse();
        // this.history_cols = Object.keys(this.history_logs[0])
        // console.log(this.history_cols);
        // console.log(this.history_logs);


      } else {
        this.loader = false;
        this.msg_view(res.msg);
      }
    });
  }

  msg_view(msg_data) {
    $(document).ready(function () {
      Materialize.toast(msg_data.toString(), 3000, "grey darken-4");
    });
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/profile/profile.component.ts